<template>
	<div class="basis-page-cls">
        <section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 数据列表</span>
            </div>
            <div class="table">
				<el-table :data="list" :header-cell-class-name="tableHeaderClassName" :row-style="tableRowClassStyle" ref="table" style="width: 100%;">
					<el-table-column label="主叫号码" prop="ani" min-width="180">
						<template slot-scope="scope">
							{{isShowPhone ? scope.row.ani : hiddenPhone(scope.row.ani)}}
						</template>
					</el-table-column>
					<el-table-column label="被叫号码" prop="dnis" min-width="180">
						<template slot-scope="scope">
							{{isShowPhone ? scope.row.dnis : hiddenPhone(scope.row.dnis)}}
						</template>
					</el-table-column>
					<el-table-column label="创建时间" prop="created" min-width="180"></el-table-column>
					<el-table-column label="回拨时间" prop="callbackTime" min-width="180"></el-table-column>
					<el-table-column label="留言信息" prop="leavemsg" min-width="180"></el-table-column>
					<el-table-column label="录入结果" min-width="180" show-overflow-tooltip>
						<template slot-scope="scope">
							<span>{{resultObj[scope.row.callbackResults]}}</span>
						</template>
					</el-table-column>
					<el-table-column label="备注" prop="callbackResultsDesc" min-width="180" show-overflow-tooltip></el-table-column>
					<el-table-column label="留言">
						<template slot-scope="scope">
							<el-button :disabled="!scope.row.recFile" @click="toogleExpand(scope.row)" type="text" icon="el-icon-service"></el-button>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="140" fixed="right" align="center">
						<template slot-scope="scope">
							<el-button :disabled="scope.row.callback == 1" type="text" @click="handleResult(scope.row)">录入结果</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-button type="text" :disabled="!scope.row.ani || scope.row.callback == 1" @click.stop="breathePhone(scope.row)">回拨</el-button>
						</template>
					</el-table-column>
					<el-table-column type="expand" width="1">
						<template slot-scope="scope">
							<Record v-if="scope.row.expansion" :auditFilePath="scope.row.recFile" />
						</template>
					</el-table-column>
				</el-table>
				<template class="pagination">
					<Pagination 
						:total="total"
						:page.sync="listQuery.pageNumber"
						:limit.sync="listQuery.pageSize"
						@pagination="getList" />
				</template>
            </div>
        </section>
		<el-dialog
			title="录入结果"
			:visible.sync="dialogVisible"
			 :modal-append-to-body="false"
			width="500px"
			center>
			<el-form :model="resultForm" ref="resultForm" label-width="85px">
				<el-form-item prop="callbackResults" label="录入结果：" :rules="[{required: true, trigger: 'blur', message: '请选择'}]">
					<el-select v-model="resultForm.callbackResults" placeholder="请选择" size="small" filterable clearable style="width: 365px">
						<el-option v-for="(item, index) in resultList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="callbackResultsDesc" label="备注：">
					<el-input v-model="resultForm.callbackResultsDesc" placeholder="请输入备注" type="textarea" size="small" :rows="2" clearable></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleResultSubmit">确 定</el-button>
			</span>
		</el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EnumMixin, tableMixin } from "utils/mixins";
import Record from "./media";
import Pagination from 'components/Basis/TablePagination/Pagination';
import { sipInit } from '../../components/Softphone/jsSipFun';
export default {
	name: 'CommunicatePageIndex',
	mixins: [EnumMixin, tableMixin],
	components: {Record, Pagination},
	computed: {
        ...mapGetters([
			'userInfo',
			'subBrandList',
			'channelList',
			'StoreAgentInfo', // ~ agent电话相关信息
			'StoreIsSignIn', // ~ 是否签入
			'StoreIsBusy', // ~ 是否置忙
			'StoreIsBusyReason', // ~ 置闲 / 置忙原因
			'StoreIsBusyReasonList',
			'isShowPhone'
        ])
    },
	data() {
		return {
			filterHeader: [
				{ label: '子品牌', model: 'subBrand', type: 'select', default: '', list: [] },
				{ label: '创建时间', model: 'date', type: 'datetimerange', default: '', placeholder: '请选择' },
				{ label: '电话号码', model: 'phoneNumber', type: 'input', default: '', placeholder: '请输入电话号码' },
				// { label: '录入结果', model: 'callback', type: 'select', default: '', list: [
				// 	{id: 1, name: '未处理'},
				// 	{id: 2, name: '已处理'}
				// ] },
			],
			listQuery: {
				pageSize: 10,
                pageNumber: 1,
				brand: '',
				subBrand: '',
				phoneNumber: '',
				endTime: '',
				startTime: '',
				date: ''
            },
			total: 0,
			list: [],
			isChrome: window.navigator.userAgent.indexOf("Chrome") > -1,
			sipDriver: null,
			dialogVisible: false,
			resultForm: {
				brand: '',
				id: '',
				callback: 1,
				callbackResults: '',
				callbackResultsDesc: ''
			},
			resultList: [
				{id: 1, name: '客户再次致电，无需回拨'},
				{id: 2, name: '经销商再次致电，无需回拨'},
				{id: 3, name: 'IT测试无法回拨'},
				{id: 4, name: '转接电话无法回拨'},
				{id: 5, name: '已回拨，并创建工单(备注工单号'},
				{id: 6, name: '已回拨，无需创建工单(备注原因'},
				{id: 7, name: '5S内掉线，无需回拨'},
				{id: 8, name: '其他情况(备注说明)'},
			],
			resultObj: {
				1: '客户再次致电，无需回拨',
				2: '经销商再次致电，无需回拨',
				3: 'IT测试无法回拨',
				4: '转接电话无法回拨',
				5: '已回拨，并创建工单(备注工单号',
				6: '已回拨，无需创建工单(备注原因',
				7: '5S内掉线，无需回拨',
				8: '其他情况(备注说明)',
			}
		}
	},
	mounted() {
		this.sipDriver = sipInit();
	},
	async created() {
		await this.getList();
		this.filterHeader[0]['list'] = await this.subBrandList;
		this.filterHeader[1]['list'] = await this.channelList;
	},
	methods: {
		getList() {
			this.listQuery.brand = this.userInfo.brandIdentify;
			this.$api.apiLeavemsgList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data ? response.data : [];
				this.list.forEach(val => {
					this.$set(val, "expansion", false);
				});
				this.total = parseInt(response.total);
			});
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
		resetForm() {
			this.resultForm = {
                brand: '',
				id: '',
				callback: 1,
				callbackResults: '',
				callbackResultsDesc: ''
			}
			if (this.$refs["resultForm"]) {
				this.$refs["resultForm"].clearValidate();
			}
		},
		breathePhone(row) {
			const self = this;
			if(!self.isChrome) {
				self.$message.error('仅支持在Chrome浏览器85版本及以上使用');
				return;
			}
			if(self.StoreIsSignIn && self.StoreIsBusy && self.StoreIsBusyReasonList.includes(self.StoreIsBusyReason) && row.ani) {
				self.$confirm(`是否向 ${row.ani} 拨打电话？`, '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// self.$api.apiPostMsgCallBackResult({
					// 	brand: row.projectCode,
					// 	id: row.id,
					// 	callback: '1'
					// }).then(response => {
						// if(response.errcode != 0) return;
						self.$store.commit('telService/SET_IS_CALL', true);
						self.sipDriver._call(row.ani, {
							brandId: self.userInfo.brandIdentify,
							channelId: 'phone',
							direction: 'OB',
							callingNumber: self.userInfo.deviceCode,
							calledNumber: row.ani
						}, '*5');
					});
				// }).catch(() => {});
			} else {
				self.$message.error('请将软电话设置为置忙 - 外呼');
			}
		},
		handleResult(row) {
			this.resetForm();
			this.resultForm.id = row.id;
			this.dialogVisible = true;
		},
		handleResultSubmit() {
			this.$refs["resultForm"].validate(valid => {
                if (valid) {
					this.resultForm.brand = this.userInfo.brandIdentify;
					// this.resultForm.callback = [5, 6].includes(this.resultForm.callbackResults) ? 1 : 0;
					this.$api.apiPostMsgCallBackResult(this.resultForm).then(response => {
						if(response.errcode != 0) return;
						this.dialogVisible = false;
						this.getList();
					});
				}
			});
		},
        filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
            this.getList();
		},
		toogleExpand(row) {
			let $table = this.$refs.table;
			this.list.map(item => {
				if (row.tuid != item.tuid) {
					$table.toggleRowExpansion(item, false);
					item.expansion = false;
				} else {
					item.expansion = !item.expansion;
				}
			});
			$table.toggleRowExpansion(row);
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .pagination-container{
	text-align: center;
}
</style>
